module.exports = __webpack_public_path__ + "static/media/mobileScreenshot03.f753aea7.jpg";